<template>
  <div class="center-it">
    <h1>{{ $t('_web_profile-not-found', 'Profile Not Found') }}</h1>
    <router-link class="link-to-home" to="/">{{
      $t('_web_error_page_message_link', 'Go back to the home page')
    }}</router-link>
  </div>
</template>
<script>
export default {
  name: 'NoProfile',
};
</script>

<style lang="scss" scoped>
.error-page {
  text-align: center;
  margin-top: 50px;
}

h1 {
  font-size: 6rem;
  font-weight: bold;
  margin-bottom: 20px;
}

p {
  font-size: 2rem;
  margin-bottom: 20px;
}
.center-it {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
}

.link-to-home {
  font-size: 1rem;
  color: rgb(68, 23, 151);
  &:hover {
    color: rgb(47, 16, 104);
  }
}
</style>
